
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'
export default Vue.extend({
  mixins: [staticBlockMixin],
  inject: ['setGlobalFormProviderProperties'],
  fetch () {
    if (+this.$route?.query?.form === this.mainFields.form?.value) {
      this.setFormSettings()
    }
  },
  mounted () {
    // this.layoutProvider.formDefault = this.mainFields?.formDefault?.value
    this.setLayoutProviderProperty('formDefault', this.mainFields?.formDefault?.value)
  },
  methods: {
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.mainFields.form?.value,
        formDefault: this.mainFields.formDefault?.value
      })
    },
    openModal () {
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.mainFields.form?.value } })
    }
  }
})
